export default class Reload {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.router.refresh();
  }
}
